import React, { useEffect, useState } from 'react';
import MidTermReserve from './midTermReserve/MidTermReserveContainer';
import { addCommas } from '@persian-tools/persian-tools';
import { useDispatch, useSelector } from 'react-redux';
import CalendarModal from './CalendarModal/CalendarModal';
import { setBasicFilters } from '@/redux/store/actions/search';
import CalenderDates from '../../../reusable/searchDatePicker/calenderDates/CalenderDates';
import PeopleCount from '../peopleCount/PeopleCount';
import Factor from '../factor/Factor';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Button from '@/components/UI/button/Button';
import styles from './PriceBox.module.scss';
import { useMidTermQuery } from '../../_hooks/useMidterm';
import { ProductItemTypes } from '../../_types/productItem.types';
import MidTermFactor from '../midTermFactor/MidTermFactor';
import PaymentSteps from '../../housesMobile/MidtermPriceBox/paymentSteps/PaymentSteps';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
type IPriceBox = {
  isNonBookable?: boolean;
  data: ProductItemTypes;
  calendarPricing: CalendarPricingType;
  onSendReserveRequestClick: any;
  loading?: boolean;
};
const PriceBox = ({
  isNonBookable,
  data,
  calendarPricing,
  onSendReserveRequestClick,
  loading
}: IPriceBox) => {
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const {
    isMidTerm
  } = useMidTermQuery(data);
  const dispatch = useDispatch();
  const isWhiteLabel = useIsWhiteLabel();
  const proformaState = useSelector(state => state.proforma);
  const [isShowModal, setIsShowModal] = useState(false);
  const [formBtnText, setFormBtnText] = useState('');
  const [blink, setBlink] = useState(false);
  useEffect(() => {
    if (!checkin || !checkout) {
      setFormBtnText('انتخاب تاریخ سفر');
    } else if (!!checkin && !!checkout && !guests) {
      setFormBtnText('انتخاب تعداد نفرات');
    } else {
      setFormBtnText(' درخواست رزرو ');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkin, checkout, guests, isMidTerm]);
  const rules = data?.rules?.records;
  const maxAccommodates = rules?.max_accommodates;
  const maxCheckin = (rules?.checkin ? rules?.checkin : rules?.checkin) + ' ' + (rules !== undefined && rules?.max_checkin_time !== null ? ` تا ${rules?.max_checkin_time}` : '');
  const minCheckout = rules?.checkout ? rules?.checkout : rules?.checkout;
  const setGuests = (value: number) => {
    dispatch(setBasicFilters({
      checkin,
      checkout,
      guests: value
    }));
  };
  const pricing = data?.pricing;
  const {
    total_payable_amount
  } = proformaState?.data || {};
  const handleSubmit = () => {
    if (!isNonBookable) {
      if (!checkin || !checkout) {
        setIsShowModal(true);
      } else if (!!checkin && !!checkout && !guests) {
        setBlink(true);
        setTimeout(() => setBlink(false), 400);
      } else {
        onSendReserveRequestClick();
      }
    }
  };
  return <Box className={styles['pricebox']} data-sentry-element="Box" data-sentry-component="PriceBox" data-sentry-source-file="PriceBox.tsx">
      <Box className={`${styles['pricebox-main']} ${isNonBookable ? styles['pricebox-main-nonbookable'] : ''}`} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
        <Box className={styles['pricebox-main-info']} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
          <Box className={styles['pricebox-main-info-pricing']} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
            <Typography className="daily-price" variant="bodyM" color={'neutral_600'} data-sentry-element="Typography" data-sentry-source-file="PriceBox.tsx">
              {total_payable_amount?.final_price ? 'مبلغ قابل پرداخت:' : isMidTerm ? 'اجاره ماهانه:' : ' قیمت هر شب از:'}
            </Typography>
            <Typography color={'neutral_900'} variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="PriceBox.tsx">
              {total_payable_amount?.final_price ? <>{addCommas(total_payable_amount?.final_price)} تومان</> : <>
                  {isMidTerm ? addCommas(pricing?.records?.[0].total_monthly_price?.amount || 0) : addCommas(pricing?.price_to_show?.amount || '')}{' '}
                  {pricing?.price_to_show?.currency_name}
                </>}
            </Typography>
          </Box>

          <Box className={styles['pricebox-main-info-datepicker']} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
            <Box onClick={() => setIsShowModal(true)} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
              <CalenderDates checkin={checkin} checkout={checkout} data-sentry-element="CalenderDates" data-sentry-source-file="PriceBox.tsx" />
            </Box>
            <PeopleCount guests={+guests} setGuests={setGuests} maxAccommodates={maxAccommodates as number} blink={blink} rules={rules} data-sentry-element="PeopleCount" data-sentry-source-file="PriceBox.tsx" />
          </Box>
          <Box className={styles['pricebox-main-info-action']} data-sentry-element="Box" data-sentry-source-file="PriceBox.tsx">
            {!isMidTerm ? <Button format="primary" onClick={handleSubmit} loading={loading} disabled={isNonBookable} size="large" suppressHydrationWarning>
                {isNonBookable ? 'اقامتگاه غیر فعال می باشد' : formBtnText}
              </Button> : <MidTermReserve hasVisitRequest={data?.has_active_request} onSendReserveRequestClick={onSendReserveRequestClick} loading={loading} />}
          </Box>
          {!isMidTerm && <Box className={styles['pricebox-main-info-chat']}>
              <Typography variant="bodyS" color={'neutral_main'}>
                امکان چت آنلاین بعد از ثبت رزرو رایگان
              </Typography>
            </Box>}

          {!!checkin && !!checkout && <>
              {isMidTerm ? <Box className={styles['pricebox-main-mid-term-payment-details']}>
                  <MidTermFactor proformaState={proformaState} />
                  <PaymentSteps />
                </Box> : <Factor checkin={checkin} checkout={checkout} proformaState={proformaState} maxCheckin={maxCheckin} minCheckout={minCheckout} />}
            </>}
        </Box>

        <CalendarModal isShowModal={isShowModal} calendarPricing={calendarPricing} setIsShowModal={setIsShowModal} minDays={data?.pricing?.records[0]?.mid_term_minimum_days} productData={data} data-sentry-element="CalendarModal" data-sentry-source-file="PriceBox.tsx" />
      </Box>
      {!isWhiteLabel && <Box className={styles['pricebox-footer']}>
          <Typography color={'neutral_600'} variant="bodyM">
            ارتباط با پشتیبانی:
          </Typography>
          <Typography color={'neutral_600'} variant="bodyM">
            88 12 11 28 - 021
          </Typography>
        </Box>}
    </Box>;
};
export default PriceBox;